export default "/images/vendor/@coreui/icons/svg/flag/cif-mk.svg?986776c51752685caf3e19c675895990";